"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _Autocomplete = _interopRequireDefault(require("../Autocomplete/Autocomplete"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AutocompleteAsync = function AutocompleteAsync(_ref) {
  var id = _ref.id,
      onRequest = _ref.onRequest,
      onSelect = _ref.onSelect,
      autoComplete = _ref.autoComplete,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      value = _ref.value,
      label = _ref.label,
      variant = _ref.variant,
      error = _ref.error,
      helperText = _ref.helperText,
      debounceTime = _ref.debounceTime,
      getOptionLabel = _ref.getOptionLabel,
      dataQa = _ref.dataQa,
      disabled = _ref.disabled,
      makeRequestOnOpen = _ref.makeRequestOnOpen,
      makeRequestOnMount = _ref.makeRequestOnMount,
      freeSolo = _ref.freeSolo;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var makeRequest = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(searchValue) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.t0 = setOptions;
              _context.next = 4;
              return onRequest(searchValue);

            case 4:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              setLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function makeRequest(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (makeRequestOnOpen && open) {
      makeRequest();
    }
  }, [open]);
  (0, _react.useEffect)(function () {
    if (makeRequestOnMount) {
      makeRequest();
    }
  }, []);

  var debounceFunc = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(searchValue) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (searchValue) {
                _context2.next = 4;
                break;
              }

              _context2.t0 = setOptions([]);
              _context2.next = 7;
              break;

            case 4:
              _context2.next = 6;
              return makeRequest(searchValue);

            case 6:
              _context2.t0 = _context2.sent;

            case 7:
              return _context2.abrupt("return", _context2.t0);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function debounceFunc(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var _useState5 = (0, _react.useState)(function () {
    return (0, _debounce["default"])(debounceFunc, debounceTime);
  }),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 1),
      debouncedCallApi = _useState6[0];

  var onInputChange = function onInputChange(event, value, reason) {
    debouncedCallApi.cancel();
    /**
     * Reason equals to "reset" when initial value is being set.
     * We should not call the API for initial value.
     */

    if (reason !== 'reset') {
      debouncedCallApi(value.trim());
      onChange(value.trim() && value);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    id: id,
    open: open,
    onOpen: function onOpen() {
      setOpen(true);
    },
    onClose: function onClose() {
      setOpen(false);
    },
    freeSolo: freeSolo,
    onSelect: onSelect,
    autoComplete: autoComplete,
    onChange: onInputChange,
    onBlur: onBlur,
    value: value,
    label: label,
    variant: variant,
    error: error,
    helperText: helperText,
    getOptionLabel: getOptionLabel,
    loading: loading,
    options: options,
    dataQa: dataQa,
    disabled: disabled
  });
};

AutocompleteAsync.propTypes = {
  id: _propTypes["default"].string,
  onRequest: _propTypes["default"].func.isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  autoComplete: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  onBlur: _propTypes["default"].func,
  value: _propTypes["default"].string,
  label: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled']),
  error: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  debounceTime: _propTypes["default"].number,
  getOptionLabel: _propTypes["default"].func.isRequired,
  dataQa: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  makeRequestOnOpen: _propTypes["default"].bool,
  makeRequestOnMount: _propTypes["default"].bool,
  freeSolo: _propTypes["default"].bool
};
AutocompleteAsync.defaultProps = {
  autoComplete: false,
  value: '',
  label: '',
  variant: 'outlined',
  debounceTime: 300,
  makeRequestOnOpen: false,
  makeRequestOnMount: false,
  freeSolo: true
};
var _default = AutocompleteAsync;
exports["default"] = _default;